// @flow

import React from 'react';
import CloseIcon from '@material-ui/icons/Close';
import {Chip, makeStyles, type ChipProps, Typography} from '@material-ui/core';
import {colors} from '../../../../../assets/styles/colors';

const useStyles = makeStyles(() => ({
  label: {
    color: '#500BDB',
    fontWeight: 500,
    fontSize: 12,
  },
  chip: {
    background: colors.lightPurple,
  },
  deleteIcon: {
    color: '#500BDB',
  },
}));

export default function OptionChip(props: ChipProps) {
  const {label, ...rest} = props;
  const classes = useStyles();

  const innerLabel = <Typography className={classes.label}>{label}</Typography>;
  return (
    <Chip
      className={classes.chip}
      label={innerLabel}
      deleteIcon={<CloseIcon className={classes.deleteIcon} />}
      {...rest}
    />
  );
}
